export enum ERouteName {
    Admin = 'admin',
    AdminAiSettings = 'adminAiSettings',
    AdminLegacy = 'adminLegacy',
    AdminLibrary = 'adminLibrary',
    AdminLibraryCategories = 'adminLibraryCategories',
    AdminProjectDetail = 'adminProjectDetail',
    AdminProjectEditor = 'adminProjectEditor',
    AdminProjects = 'adminProjects',
    AdminReferenceDetail = 'adminReferenceDetail',
    AdminReferences = 'adminReferences',
    AdminTemplateDetail = 'adminTemplateDetail',
    AdminTemplateEditor = 'adminTemplateEditor',
    AdminTemplates = 'adminTemplates',
    AdminTemplateThemes = 'adminTemplateThemes',
    Configurator = 'configurator',
    ConfiguratorAdmin = 'configuratorAdmin',
    ConfiguratorAdminTemplate = 'configuratorAdminTemplate',
    ConfiguratorTemplate = 'configuratorTemplate',
    Login = 'login',
    ProductSelection = 'productSelection',
}
